import React, { Component } from 'react';
import { connect } from 'react-redux';

class Encabezado extends Component {

  render(){
    if(this.props.encabezado.redirect!==undefined && this.props.encabezado.redirect!==null &&
        this.props.encabezado.redirect!==""){
      window.location.replace(this.props.encabezado.redirect)
    }
    if (this.props.encabezado.text===null || this.props.encabezado.text==="") {
      return <div id="empty-subtitle"></div>
    }
    return (
      <section id="subtitle">
        <div className="sub-title">
          <div className="container">
            {this.props.encabezado.text}
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps({ encabezado }) {
  return { encabezado };
}

export default connect(mapStateToProps)(Encabezado);



// WEBPACK FOOTER //
// ./src/containers/encabezado.js